import { API_URL, MOKA_INVENTORY_API } from 'api/constants';

// TODO remove
export const ITEMS = `${API_URL}/v2/items`;

export const V3_ITEMS = `${API_URL}/v3/items`;

export const V2_ITEMS = `${API_URL}/v2/items`;

export const V1_ITEMS = `${MOKA_INVENTORY_API}/v1/items`;

export const V1_ITEM_BY_ID = id => `${V1_ITEMS}/${id}`;

export const V1_IMPORT_ITEMS_TEMPORARY = `${V1_ITEMS}/import_items_temporary`;

export const V3_IMPORT_ITEMS_TEMPORARY = `${V3_ITEMS}/import_items_temporary`;

export const V1_IMPORT_ITEMS = `${V1_ITEMS}/import_items`;

export const V3_IMPORT_ITEMS = `${V3_ITEMS}/import_items`;

export const V1_IMPORT_ITEMS_TEMPLATE = `${V1_ITEMS}/import_items_template`;

export const V3_IMPORT_ITEMS_TEMPLATE = `${V3_ITEMS}/import_items_template`;

export const ITEMS_NEW = `${MOKA_INVENTORY_API}/v1/items`;

export const ITEM_BY_ID_NEW = id => `${ITEMS_NEW}/${id}`;

export const ITEM_IMPORT_V1_INVENTORY = `${ITEMS_NEW}/import`;

export const IMPORT_ITEMS_TEMPLATE_V1_INVENTORY = `${ITEMS_NEW}/export`;
